
/**
 Check the lookFor but also that the #2 is not in the name, i.e. Street Address 2
**/ 
export function isField(field, lookFor, exclude){

  var check = false; 

  if(!!field.labels){

    lookFor.forEach(function(t){
      // Check Label
      if(field.labels.length > 0){
        var labelText = field.labels[0].innerText.toLowerCase();
        
        if( labelText.indexOf(t) > -1 ){
          
          if(exclude.length > 0 && Array.isArray(exclude)){
            
            check = true;
            exclude.forEach(function(x){
              if(labelText.includes(x)){
                check = false;
              }
            });
            return false;
          }else{
            check = true;
            return false;
          }
        }
      }
      
      //Check Name
      if(field.name.toLowerCase().indexOf(t) > -1 ){
        if(exclude.length > 0 && Array.isArray(exclude)){

          exclude.forEach(function(x){
            if(field.name.indexOf(x) === -1){
              check = true;
              return check;
            }
          });
        }else{
          check = true;
          return check;
        }
      }
    });
  }
  return check; 
}    

/**
 Check the lookFor but also that the #2 is not in the name, i.e. Street Address 2
**/ 
export function getField(context, lookFor, exclude){

  var field = {};
  context.forEach(function(c){
    // isField()
    // console.log('field', c);
    if(isField(c, lookFor, exclude)){
      field = c;
      return false;
    }
  });
  return field;
}